export default function getListCountries(data) {
  let countries = [];
  for (let item of data) {
    countries.push({id: item.id, name: item.name});
  }
  return countries;
}
